import React, { useState, useContext, SyntheticEvent } from "react";
import { useTranslation } from "react-i18next";

//MUI
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

//Custom
import OperationsContext from "@/components/OperationsContext/OperationsContext";

//Types
import { PickerItem } from "@/@types/controls/controls";
import { AutocompleteChangeReason } from "@mui/material";
import { OperationsContextType } from "@/components/OperationsContext/OperationsContext";

const OperationsFishnetPicker = () => {

  const operationsContext = useContext<OperationsContextType>(OperationsContext);

  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  const label = "operations.select_fishnet";
  const loadingText = "operations.loading";

  const handleChange = (evt: SyntheticEvent, value: PickerItem | null, reason: AutocompleteChangeReason) => {
    switch (reason) {
      case "createOption":
        break;
      case "selectOption":
        applyChange(value);
        break;
      case "removeOption":
        break;
      case "clear":
        applyChange(null);
        break;
      case "blur":
        break;
    }
  };

  const applyChange = (option: PickerItem | null) => {
    if (option) {
      operationsContext.selectFishnet(option.value as number);
    } else {
      operationsContext.selectFishnet(null);
    }
  };

  const p = operationsContext.selectedFishnet;
  const selectedItem = p ? { value: p.id, label: p.sifra} as PickerItem : null;
  const customStyle = selectedItem === null ? { backgroundColor: "#f00" } : {};

  const isDisabled = operationsContext.fishnetItems.length === 0 ? true : false;

  return (
    <Autocomplete
      disabled={isDisabled}
      disablePortal
      size="small"
      options={operationsContext.fishnetItems}
      value={selectedItem}
      getOptionLabel={(option: PickerItem) => `${option.label}`}
      isOptionEqualToValue={(option: PickerItem, value: PickerItem) => option.value == value.value}
      autoHighlight={true}
      renderInput={(params) => {
        return (
          <TextField 
            {...params}
            placeholder={t(label)}
            variant="outlined"
            required={false}
            label={undefined}
            sx={{ ml: 2, width: 200 }} 
            InputProps={{
              sx: {
                color: "#FFF",
                ...customStyle
              },
              ...params.InputProps
            }}
            />

        )
      }
      }
      onChange={handleChange}
      loading={isLoading}
      loadingText={t(loadingText)}
    />
  )
}

export default OperationsFishnetPicker;